<style scoped>
#terms {
	padding: 10px;
	margin: 0px;
	min-width: 100%;
	min-height: 100%;
}
</style>

<template>
	<div id="terms">
		<div>Terms and conditions to come here soon...</div>
		<a style="color: #DADADA;" @click.prevent="go_back();">
			&lt;&lt; back
		</a>
	</div>
</template>

<script>
export default {
	name: "Terms",
	methods: {
		go_back: function() {
			this.$router.push('/logon');
		}
	}
}
</script>
